import { chargingTransactionActionTypes } from "../../actionTypes/transactions/chargingTransaction.actionTypes";

export const setChargingTransaction = (chargingTransaction) => async (dispatch) => {
  dispatch({ type: chargingTransactionActionTypes.SET_CHARGING_TRANSACTION, payload: chargingTransaction });
};

export const chargingTransctionActions = {
  setChargingTransaction,
};
